/* bvm-account.js — il cassetto Account (snippets/bvm-account.liquid), BVM 20/10/2026. Solo da 1000 px: sotto, il bottone e il cassetto
   non ci sono e l'icona resta quella di Shopify. Fa:
   · apri / chiudi dal bottone Account dell'header ([data-bvm-account-apri]) e dalla × ([data-bvm-account-chiudi]); Esc chiude;
     un clic fuori dal cassetto chiude;
   · il fuoco: all'apertura va sulla ×, Tab e Maiusc+Tab restano dentro il cassetto, alla chiusura torna sul bottone Account;
   · la tinta dell'icona: aria-expanded del bottone (CSS in assets/bvm-account.css);
   · Carrello e Account si escludono: aprendo l'Account si chiude il mini carrello (la sua × del tema), aprendo il mini carrello
     (aria-hidden="false", lo mette assets/theme.js) si chiude l'Account;
   · «Accedi con Shop»: chiude il cassetto e apre il pannellino di Shopify (il bottone dentro <shopify-account>); se non lo trova il link
     porta alla pagina d'accesso;
   · le tessere del cliente entrato: se ne apre una alla volta. */
(function () {
  var mq = window.matchMedia('(min-width: 1000px)');
  var SEL_FUOCO = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function via() {
    var c = document.getElementById('bvm-account'), b = document.querySelector('[data-bvm-account-apri]');
    if (!c || !b) return;
    var mc = document.getElementById('mini-cart'), x = c.querySelector('[data-bvm-account-chiudi]');
    var aperto = function () { return c.getAttribute('aria-hidden') === 'false'; };
    function tasti(e) {
      if (e.key === 'Escape') { e.preventDefault(); chiudi(true); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(c.querySelectorAll(SEL_FUOCO), function (el) { return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden'; });
      if (!f.length) return;
      var primo = f[0], ultimo = f[f.length - 1];
      if (!c.contains(document.activeElement)) { e.preventDefault(); primo.focus(); }
      else if (e.shiftKey && document.activeElement === primo) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primo.focus(); }
    }
    function fuori(e) { if (!c.contains(e.target) && !b.contains(e.target)) chiudi(false); }
    function apri() {
      if (!mq.matches || aperto()) return;
      if (mc && mc.getAttribute('aria-hidden') === 'false') { var mx = mc.querySelector('.bvm-mc-chiudi') || mc.querySelector('[data-action="toggle-mini-cart"]'); if (mx) mx.click(); }
      c.setAttribute('aria-hidden', 'false'); b.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', tasti); document.addEventListener('click', fuori, true);
      setTimeout(function () { if (aperto() && x) x.focus(); }, 60);
    }
    function chiudi(ritorna) {
      if (!aperto()) return;
      c.setAttribute('aria-hidden', 'true'); b.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', tasti); document.removeEventListener('click', fuori, true);
      if (ritorna) b.focus();
    }
    b.addEventListener('click', function (e) { e.preventDefault(); if (aperto()) chiudi(true); else apri(); });
    if (x) x.addEventListener('click', function () { chiudi(true); });
    if (mc && window.MutationObserver) new MutationObserver(function () { if (mc.getAttribute('aria-hidden') === 'false') chiudi(false); }).observe(mc, { attributes: true, attributeFilter: ['aria-hidden'] });
    var cambio = function () { if (!mq.matches) chiudi(false); };
    if (mq.addEventListener) mq.addEventListener('change', cambio); else if (mq.addListener) mq.addListener(cambio);
    // «Accedi con Shop»: il pannellino di Shopify (il componente resta nell'header, invisibile da 1000 px)
    var shop = c.querySelector('[data-bvm-account-shop]');
    if (shop) shop.addEventListener('click', function (e) {
      var sa = document.querySelector('.header__action-item--account shopify-account'), bt = sa && sa.shadowRoot && sa.shadowRoot.querySelector('button');
      if (!bt) return;
      e.preventDefault(); chiudi(false); setTimeout(function () { bt.click(); }, 30);
    });
    // tessere: una alla volta
    var tessere = c.querySelectorAll('[data-bvm-acc-tessera]');
    Array.prototype.forEach.call(tessere, function (t) {
      var h = t.querySelector('.bvm-acc-tessera__testa');
      h.addEventListener('click', function () {
        var apre = h.getAttribute('aria-expanded') !== 'true';
        Array.prototype.forEach.call(tessere, function (u) { u.classList.remove('is-aperta'); u.querySelector('.bvm-acc-tessera__testa').setAttribute('aria-expanded', 'false'); });
        if (apre) { t.classList.add('is-aperta'); h.setAttribute('aria-expanded', 'true'); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', via); else via();
})();
